module.exports = __webpack_public_path__ + "img/Frame 5107.e269e449.jpg";